const lookupKeyFromValue = (enumeratedType, value) => {
  return Object.entries(enumeratedType).find(([, v]) => v === value)?.[0];
};
const safeSum = (...numbers) => {
  let res = 0;
  numbers.forEach((num) => {
    res += Number(num || 0);
  });
  return res;
};
const formatDate = (date, formatType) => {
  const config = {
    Calendar: (d) => {
      return [
        (d.getMonth() + 1).toString().padStart(2, "0"),
        d.getDate().toString().padStart(2, "0"),
        d.getFullYear()
      ].join("/");
    },
    ISODateOnly: (d) => {
      return d.toISOString().split("T")[0];
    }
  };
  let parsed;
  if (date instanceof Date) {
    parsed = date;
  } else if (typeof date === "string" && date?.length >= 10) {
    const dateParts = date.substring(0, 10).replace(/[-/]/g, "/").split("/");
    const isYearFirst = dateParts[0].length === 4;
    const americanCalendarStyle = (isYearFirst ? [dateParts[1], dateParts[2], dateParts[0]] : [dateParts[0], dateParts[1], dateParts[2]]).join("/");
    parsed = new Date(americanCalendarStyle);
  } else {
    return null;
  }
  if (!parsed || !Number.isFinite(parsed?.getTime())) {
    return null;
  }
  return config[formatType]?.(parsed) ?? null;
};
const isEmpty = (value) => {
  return value == null || // From standard.js: Always use === - but obj == null is allowed to check null || undefined
  typeof value === "object" && Object.keys(value).length === 0 || typeof value === "string" && value.trim().length === 0;
};
const partitionArray = (array, isValid) => array.reduce(
  ([pass, fail], elem) => isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]],
  [[], []]
);
export {
  formatDate,
  isEmpty,
  lookupKeyFromValue,
  partitionArray,
  safeSum
};
